import { Input } from '@builder.io/sdk';

/** Sub Components. */
export const alignment = {
  name: 'alignment',
  type: 'text',
  defaultValue: 'center',
  enum: ['left', 'center', 'right']
} satisfies Input;
